import { AdditionalFees, FeesTab, MonthlyFees } from "models";

import { ACHProcessorValues } from "./achProcessorValues";

const feesInitialValues = {
	...new FeesTab(),
	...new AdditionalFees(),
	...new MonthlyFees(),
};

const achValues = new ACHProcessorValues();

export const MpaInitialValues = {
	...feesInitialValues,
	primaryContact: { isPrimaryContactTheSame: "true" },
	businessAddress: {},
	legalAddress: {
		isLegalAddressTheSame: "true",
	},
	ownerPrincipalSection: {
		owners: [],
	},
	isAddMoreInfo: "false",
	accountType: "1",
	monthlyAMEX: "",
	avgTicketAMEX: "",
	highTicketAMEX: "",
	...achValues,
};
